import React from 'react'

import {
  AIGeneratedGradientFilled, Button, Icon, Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

export const EDIT_WITH_AI_LABEL = 'Edit with AI'

export const buildEditWithAiHref = itemSlug => `/ai-3d-model-generator/3d-models/${encodeURIComponent(itemSlug)}`

const ICON_SIZE = { width: '16', height: '16' }

function EditWithAiAction({
  itemSlug,
  isDisabled = false,
  disabledMessage = '',
  tooltipId = '',
  className = '',
}) {
  const customClass = `edit-with-ai-action ${className}`.trim()
  const icon = (
    <Icon
      svgComponent={AIGeneratedGradientFilled}
      size={ICON_SIZE}
      className="edit-with-ai-action__icon"
    />
  )

  if (isDisabled) {
    const button = (
      <Button
        type="secondary"
        size="small"
        actionType="button"
        icon={icon}
        customClass={customClass}
        disabled
        aria-disabled
      >
        {EDIT_WITH_AI_LABEL}
      </Button>
    )

    return (
      <Tooltip id={tooltipId} randomizeID content={disabledMessage} place="top">
        {button}
      </Tooltip>
    )
  }

  return (
    <Button
      type="secondary"
      size="small"
      href={buildEditWithAiHref(itemSlug)}
      icon={icon}
      customClass={customClass}
      title={EDIT_WITH_AI_LABEL}
    >
      {EDIT_WITH_AI_LABEL}
    </Button>
  )
}

EditWithAiAction.propTypes = {
  itemSlug: string.isRequired,
  isDisabled: bool,
  disabledMessage: string,
  tooltipId: string,
  className: string,
}

export default EditWithAiAction
